var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.styles(), attrs: { id: "tp-footer" } }, [
    _c(
      "a",
      {
        attrs: {
          href: _vm.tpLink,
          "aria-label": "touchpoint restaurant innovations platform",
          target: "_blank",
          rel: "noopener"
        }
      },
      [
        _c("BaseIcon", {
          attrs: {
            editStroke: false,
            classNames: ["tp-logo"],
            icon: "tpLogo",
            isCustom: true
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("p", { staticClass: "is-size-7" }, [
      _vm._v("This store runs on Touchpoint Restaurant Innovations platform. "),
      _c(
        "a",
        { attrs: { href: _vm.tpLink, target: "_blank", rel: "noopener" } },
        [_vm._v("Learn more")]
      ),
      _vm._v(" | "),
      _c(
        "a",
        { attrs: { href: _vm.tpLink, target: "_blank", rel: "noopener" } },
        [_vm._v("Contact us")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "version-container" }, [
      _c("span", { staticClass: "version-label" }, [
        _vm._v(_vm._s(_vm.getVersion))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96e2c46a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96e2c46a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/TPFooter.vue
// module id = null
// module chunks = 